import {
  createTheme,
  LinearProgress,
  ThemeProvider,
  StyledEngineProvider,
} from '@mui/material';
import React from 'react'
import { styleVariables } from '../../../utils/constants';
import './lineLoader.scss';

interface Props
{
  className?: String,
  wrapperClassName?: String
}

const datePickerTheme = createTheme({
  components: {
    MuiLinearProgress: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: '#fff'
        },
        barColorPrimary: {
          backgroundColor: styleVariables.primaryMain
        }
      }
    }
  }
});

const LineLoader: React.FC<Props> = ({
  className = '',
  wrapperClassName = '',
  ...otherProps
}) =>
{
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={datePickerTheme}>
        <div className={`lineLoaderWrapper ${wrapperClassName}`}>
          <LinearProgress
            aria-label='Loading'
            className={`lineLoader ${className}`}
            {...otherProps}
          />
        </div>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default LineLoader;
